import { DisplayType } from "@uiview/views/Nodes/typing";
import { DIRECTIONHANDLE } from "@views/thinking-layout-editor/constants";
import { GetZoom, Node, SetCenter } from "reactflow";
import { createContainer } from "unstated-next";
/**
 * HomeUsePlugin child 容器
 *
 * - 只要是 HomeUsePlugin 组件子节点都可以通过 `useHomeUsePlugin` 得到内部数据和逻辑，可避免深度传递
 *
 * @returns
 */
type ParamsType = {
  nodeDataRef: React.MutableRefObject<{
    [key: string]: any;
  }>;
  getSimpleNodeData: (node: any) => any;
  getSaveDataV3: (templateObj?: object, edges?: any, variableList?: any, params?: object) => any;
  handleCustomToGroup: (preNodeId: string, newNodeArr: Array<any>) => any;
  getAndSetQueryV3: (id: string, text: string) => Promise<{ lineType: string; identifier: any } | undefined>;
  clickRunAllBtn: (sourceNodeArr: any[], isFromPreview: boolean) => Promise<void>;
  /**
   * @deprecated use `FotSaveService.handleSave`
   */
  handleSave: (data: any) => Promise<any>;
  handleHiddenNode: (arr: any[]) => any[];
  emptyPreviewApp: (byUnpublish: boolean) => void;
  autoSelectTemplate: (byUnpublish: boolean, autoAddInput: boolean) => void;
  addToPreviewList: (info?: PreviewApp.FormatChooseAppType | null) => void;
  resetStartNodeIds: (isStatic: boolean) => void;
  getUIListParam: () => any[];
  handleGroupToCustom: (preNodeId: string, newNode: any) => any;
  handleInputField: (currentNode: any, type?: string, cotDescription?: string) => void;
  clickAddNodeBtn: (e: any, data?: Record<string, any>) => { nodeId: string };
  autoAddInputNodeByBluePrint: (param: {
    edgeNode: Node;
    nodes: Array<Node<any>>;
    inputs: Array<{ description: string; name: string; type: string }>;
  }) => void;
  addThink: (word: string) => void;
  showAllInputs: (saasInputNodeIds: any, saasNodes: any, index?: number) => Promise<void>;
  genLink: () => any;
  clickAddBtn: (
    direction: keyof typeof DIRECTIONHANDLE,
    otherProps: Record<string, any>,
    setCenter: SetCenter,
    displayType: DisplayType
  ) => void;
  clickSliceBtn: (id: any) => Promise<void>;
  addOrRemoveInputFeild: (node: any) => void;
  clickGroupAddBtn: (
    direction: keyof typeof DIRECTIONHANDLE,
    otherProps: Record<string, any>,
    setCenter: SetCenter,
    getZoom: GetZoom,
    displayType: DisplayType
  ) => void;
};
function useContainer(props?: ParamsType): ParamsType {
  return props as ParamsType;
}

export const HomeChildContainer = createContainer(useContainer);
export const { Provider: HomeChildProvider, useContainer: useHomeChildContainer } = HomeChildContainer;
